/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

class PanelOpener extends HTMLElement {
    connectedCallback() {
        this.querySelector('button').addEventListener('click', () => {
            const panel = document.getElementById(this.dataset.panel);
            if (panel) panel.open();
        });
    }
}

class PanelDrawer extends HTMLElement {
    connectedCallback() {
        this.querySelectorAll('[data-close]').forEach((el) => {
            el.addEventListener('click', () => this.close());
        });

        this.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.close();
        });
    }

    open() {
        this.classList.remove('invisible');
        this.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
        this.focus();
        this._trapFocus();
    }

    close() {
        this.classList.add('invisible');
        this.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
        document
            .querySelector(`panel-opener[data-panel="${this.id}"] button`)
            ?.focus();
    }

    _trapFocus() {
        const focusable = Array.from(
            this.querySelectorAll(
                'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
            )
        );
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        this._focusTrapHandler = (e) => {
            if (e.key !== 'Tab') return;
            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };

        this.addEventListener('keydown', this._focusTrapHandler);

        const cleanup = () => {
            this.removeEventListener('keydown', this._focusTrapHandler);
            this.removeEventListener('close-panel', cleanup);
        };
        this.addEventListener('close-panel', cleanup);
    }
}

customElements.define('panel-opener', PanelOpener);
customElements.define('panel-drawer', PanelDrawer);